import { render, staticRenderFns } from "./m-article-text.vue?vue&type=template&id=85a82fa8"
import script from "./m-article-text.vue?vue&type=script&lang=js"
export * from "./m-article-text.vue?vue&type=script&lang=js"
import style0 from "./m-article-text.vue?vue&type=style&index=0&id=85a82fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports